import { Fragment, ReactElement, useMemo } from 'react';
import { MarriageDetailNotificationsNonResidentCrumbs } from 'notifications-from-civil-status/constants/breadcrumb';
import { IdAmbito } from 'shell/constants/id-ambito';
import { MarriageDetailNotificationsNonResidentSubscriptionCrumbs } from 'subscription/constants/breadcrumb';
import { MarriageDetailNotificationsNonResidentMutationCrumbs } from 'mutation/constants/research-notifications-civil-status.crumbs';
import { MarriageDetailNotificationsNonResidentCancellationsCrumbs } from 'cancellations/constants/breadcrumb';
import { getBaseUrl } from 'notifications-from-civil-status/utils/get-base-url';
import { useParams } from 'react-router-dom';
import { MarriageDetailNotificationsNonResidentCivilStatusCrumbs } from 'civil-status/constants/breadcrumb';
import ResearchMarriageNonResidentDetailNotificationsShared from 'shell/components/shared/research-notifications/research-marriage-non-resident/detail';

interface ResearchMarriageDetailNotificationsCivilStatusSharedProps {
  scope?: string;
  isOther?: boolean;
  isCivilStatus?: boolean;
}

const ResearchMarriageNonResidentDetailNotificationsCivilStatusShared = ({
  scope,
  isOther,
  isCivilStatus,
}: ResearchMarriageDetailNotificationsCivilStatusSharedProps): ReactElement => {
  const params = useParams();

  const idNotifica = params.idNotifica || '';
  const idCat = params.idCat || undefined;
  const idAnsc = useMemo(() => {
    return params.id || undefined;
  }, [params.id]);

  const baseUrl: string = useMemo(() => {
    return getBaseUrl(scope, idCat);
  }, [scope]);

  const goBackUrl: string = useMemo(() => {
    return `${baseUrl}/modifica/${idAnsc}/${idNotifica}`;
  }, [baseUrl, idAnsc, idNotifica]);

  const goBackUrlDetail: string = useMemo(() => {
    return `${getBaseUrl(scope, idCat)}/visualizza/${idAnsc}/${idNotifica}`;
  }, [scope, idAnsc, idCat]);

  const items = useMemo(() => {
    if (idCat) {
      return MarriageDetailNotificationsNonResidentCivilStatusCrumbs(goBackUrl, idCat);
    }

    if (!scope) {
      return MarriageDetailNotificationsNonResidentCrumbs(goBackUrl);
    }

    switch (scope) {
      case IdAmbito.Iscrizioni:
        return MarriageDetailNotificationsNonResidentSubscriptionCrumbs(goBackUrl);
      case IdAmbito.Mutazioni:
        return MarriageDetailNotificationsNonResidentMutationCrumbs(goBackUrl);
      case IdAmbito.Cancellazioni:
        return MarriageDetailNotificationsNonResidentCancellationsCrumbs(goBackUrl);
      default:
        return [];
    }
  }, [scope, idCat]);

  return (
    <Fragment>
      <ResearchMarriageNonResidentDetailNotificationsShared
        goBackUrl={isCivilStatus ? goBackUrl : `${goBackUrl}/matrimonio/non-residenti`}
        editSipoUrl={`${goBackUrl}/matrimonio/non-residenti/registrazione/:idIntestatario/:idSchedaSoggettoANPR/persona-sipo`}
        goBackUrlDetail={goBackUrlDetail}
        items={items}
        isOther={isOther}
      />
    </Fragment>
  );
};

ResearchMarriageNonResidentDetailNotificationsCivilStatusShared.displayName =
  'Research Marriage Detail Notifications CivilStatusShared component';

export default ResearchMarriageNonResidentDetailNotificationsCivilStatusShared;
